import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Wish } from "./wish.model";

@Injectable({
  providedIn: "root"
})
export class WishesService {

  constructor(private httpClient: HttpClient) { }
  
  getJsonWishlist(): Observable<Wish[]> {
    return this.httpClient.get<Wish[]>("assets/wishes.json");
  }
}

